<template>
<div class="pure-u-1 pure-u-md-5-6 pure-u-lg-3-4 pure-u-xl-2-3 container">

  <app-header></app-header>

  <Calendar v-if="isCalendarVisible"
    :year="year" :month="month" v-on:updateMonthYear="updateMonthYear"
    v-on:selectDate="selectDate" />

  <div class="pure-g">
    <Note :year="date.year" :month="date.month" :date="date.date" class="pure-u-1"/>
  </div>

</div>

</template>
<script type="text/javascript">
  import { mapGetters } from "vuex";
  import appHeader from "@/components/Header";
  import Note from "@/components/Note";
  import Calendar from "@/components/Calendar";
  import calendarMixin from "@/mixins/calendar";

  export default {
    name: "home",
    data() {
      return {
      };
    },
    computed: {
      ...mapGetters([
        "user",
        "isCalendarVisible",
        "month",
        "year",
        "date",
      ]),
    },
    mixins: [calendarMixin],
    components: {
      appHeader,
      Note,
      Calendar,
    },
    created() {
      const today = new Date();
      this.updateMonthYear({ year: today.getFullYear(), month: today.getMonth() + 1 });
      this.updateDate({ year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate() });
    },
  };
</script>
<style>

</style>



// WEBPACK FOOTER //
// HomePage.vue?53efd054